export default {
  outlined: {
    transform: 'translate(14px, 12px) scale(1)'
  }
};
